const sidebarName_en = {
  exhibitorAdmin: "Exhibitor Admin.",
  visitorAdmin: "Visitor Admin.",
  forumAdmin: "Fourm Admin.",
  guestSeats: "guests seats",
  forumTable: "Forum"
}

const sidebarName_ch = {
  exhibitorAdmin: "展商管理",
  visitorAdmin: "观展管理",
  forumAdmin: "论坛管理",
  guestSeats: "嘉宾席位",
  forumTable: "论坛列表"
}
export {
  sidebarName_ch,
  sidebarName_en
}
